export default {
    urlApi: "https://maps.googleapis.com/maps/api/js?key=AIzaSyCrNDMfM-Omfn0KAz4-L3aYaTuqwh_Fbs0&libraries=places",
    mapOptions: {
        'loadApi': {
            'api': "AIzaSyCrNDMfM-Omfn0KAz4-L3aYaTuqwh_Fbs0"
        },
        'libs': [
            'https://libs.cartocdn.com/cartodb.js/v3/3.15/cartodb.js'
        ]
    }
}